import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M16.25 16.25H3.75l-2-9.5 4.75 2.5 3.5-5.5 3.5 5.5 4.75-2.5-2 9.5Z"
	})]
});
const ForwardRef = forwardRef(SvgCrown);
export { ForwardRef as ReactComponent };
